import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import {
  Farmer,
  Document,
  Season,
  SeasonParticipant,
  TaskAssignment,
} from 'types/common';
import { FarmerGroupV2 } from 'types/response';

type PreHarvestMeetingResponse = {
  id: string;
  taskAssignment: TaskAssignment;
  preHarvestMeetingDto: PreHarvestMeeting;
};

type PreHarvestMeeting = {
  id: string;
  meetingDate: string;
  estimatedHarvestDateStatus: string;
  originalEstimatedHarvestDate: string;
  updatedEstimatedHarvestDate: string;
  reason: string;
  meetingSummary: string;
  fieldCondition: string;
  cube: FarmerGroupV2;
  season: Season;
  participants: {
    id: string;
    farmer: Farmer;
    seasonParticipant: SeasonParticipant;
  }[];
  images: Document[];
};

const usePreHarvestQuery = (id?: string, enabled: boolean = true) => {
  const query = useQuery<AxiosResponse<PreHarvestMeetingResponse>>({
    queryKey: ['pre-harvest-meeting', id],
    queryFn: () => API.get('tasklog/pre-harvest/' + id),
    enabled: !!id && enabled,
  });

  return query;
};

export default usePreHarvestQuery;
